import React from "react";
import { DialogButton, SimpleDialog } from "../../dialog";

export const PendingUploadsDialog = ({
	continueText,
	titleText,
	messageText,
	returnToProductText,
	open,
	onClose,
}: {
	continueText: string | undefined;
	titleText: string;
	messageText: string;
	returnToProductText: string;
	open: boolean;
	onClose(hasPendingUploads: false | undefined): void;
}) => {
	const Footer = () => (
		<>
			<DialogButton
				// eslint-disable-next-line jsx-a11y/no-autofocus
				autoFocus={!continueText}
				onClick={() => onClose(undefined)}
			>
				{returnToProductText}
			</DialogButton>
			{continueText ? (
				<DialogButton
					// eslint-disable-next-line jsx-a11y/no-autofocus
					autoFocus
					onClick={() => onClose(false)}
				>
					{continueText}
				</DialogButton>
			) : null}
		</>
	);
	return (
		<SimpleDialog
			className="pending-uploads-dialog"
			isOpen={open}
			onScrimClick={() => onClose(undefined)}
			onCloseIcon={() => onClose(undefined)}
			title={titleText}
			footer={<Footer />}
		>
			{messageText}
		</SimpleDialog>
	);
};
PendingUploadsDialog.displayName = "PendingUploadsDialog";
